/**
 * Generate a consistent gradient based on user's name.
 * This ensures the same user always gets the same avatar color across the entire app.
 */
export function getGradientFromName(firstName?: string | null, lastName?: string | null): string {
  const name = `${firstName || ''}${lastName || ''}`;
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    const codePoint = name.codePointAt(i);
    if (codePoint !== undefined) {
      hash = codePoint + ((hash << 5) - hash);
    }
  }
  
  const gradients = [
    'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
    'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
    'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)',
    'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
    'linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)',
    'linear-gradient(135deg, #ff9a9e 0%, #fecfef 100%)',
    'linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)',
    'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    'linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)',
  ];
  
  return gradients[Math.abs(hash) % gradients.length];
}

const NAME_COLORS = [
  '#667eea', '#f5576c', '#4facfe', '#43e97b', '#fa709a', '#6a11cb',
  '#e85d04', '#9d4edd', '#06d6a0', '#ef476f',
];

export function getColorFromName(firstName?: string | null, lastName?: string | null): string {
  const name = `${firstName || ''}${lastName || ''}`;
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    const codePoint = name.codePointAt(i);
    if (codePoint !== undefined) hash = codePoint + ((hash << 5) - hash);
  }
  return NAME_COLORS[Math.abs(hash) % NAME_COLORS.length];
}

/**
 * Get initials from first and last name
 */
export function getInitials(firstName?: string | null, lastName?: string | null): string {
  return `${firstName?.[0] || ''}${lastName?.[0] || ''}`.toUpperCase() || '?';
}
